import React, { FC, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import styles from './top_limitation.module.scss';

type Props = {
  hiddenResults: number;
  totalHits: number;
  showHiddenResults: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const TopLimitationMessage: FC<Props> = ({
  totalHits,
  hiddenResults,
  showHiddenResults,
}) => {
  useEffect(() => {
    const resultsShown = totalHits - hiddenResults;
    doctrineAnalytics('Search CutResultViewed', {
      nb_results_shown: resultsShown,
      nb_results_hidden: hiddenResults,
    });
  }, []);

  return (
    <div className={styles.container} data-test-id="top-limitation-message">
      <FormattedMessage id="TopLimitationMessage/1" />{' '}
      <button
        type="button"
        data-test-id="show-hidden-results"
        className={styles.link}
        onClick={showHiddenResults}
      >
        <FormattedMessage
          id="TopLimitationMessage/2"
          values={{
            hiddenResults,
          }}
        />
      </button>
    </div>
  );
};
